var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 72,
    viewBox: "0 0 112 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.654 6.2248V62.0732H1.74673V6.21723C1.74673 3.92617 3.3783 2.11881 5.30788 2.11881H105.086C107.022 2.11881 108.654 3.92617 108.654 6.2248ZM105.086 1.19531H5.30788C2.83667 1.19531 0.882812 3.48768 0.882812 6.21723V65.6734C0.882812 68.4108 2.8369 70.6953 5.30788 70.6953H105.086C107.564 70.6953 109.511 68.4105 109.511 65.6734V6.21723C109.511 3.47984 107.557 1.19531 105.086 1.19531ZM108.654 65.6734C108.654 67.9648 107.022 69.7794 105.086 69.7794H5.30788C3.37195 69.7794 1.74011 67.9648 1.74011 65.6734V62.9967H108.654V65.6734Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4854 13.9987L20.9922 49.1793",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.383 14.0519C91.2309 14.4905 91.3367 15.1484 91.4823 15.5719C91.6345 14.8308 91.919 14.1048 92.3888 13.5452C91.7139 13.5679 91.0654 13.2805 90.4766 12.925C90.6751 13.3561 90.9794 13.8477 91.383 14.0443V14.0519Z",
    fill: "#F69A4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0917 49.1267C21.4754 49.3007 21.8261 49.8376 21.9981 50.246C21.4225 49.8679 20.7608 49.6183 20.0859 49.6259C20.5557 49.0814 20.8138 48.3327 20.9924 47.5991C21.1314 48.0604 21.2438 48.6503 21.0917 49.1192V49.1267Z",
    fill: "#F69A4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7362 7.05688H9.78125V13.8631",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7362 7.05688H9.78125V13.8631",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7362 56.523H9.78125V49.7168",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7656 7.05688H102.721V13.8631",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7656 56.523H102.721V49.7168",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.5f6c57006617aac84d8db7e21e1ad40e.svg";
export { ForwardRef as ReactComponent };